
const state = {};

const mutations = {
  ADD_PARAM (state, { key, value }) {
    state[key] = value;
  },
};

const actions = {
  init ({ commit }) {
    let url = window.location.href;
    let start = url.indexOf('?');
    let stop = (url.indexOf('#') > -1) ? url.indexOf('#') : url.length;
    let queryString = (start > -1) ? url.substr(start + 1, stop - start - 1) : '';

    queryString.split('&')
      .map(p => p.split('='))
      .forEach(p => commit('ADD_PARAM', { key: p[0], value: p[1] }));
  },
};

export default {
  state,
  mutations,
  actions,
  namespaced: true,
};
